import { Box } from "@mui/material";
import { ConfirmationCardProps } from "./ConfirmationCard.types";
import CardWrapper from "../../../../common/cards/CardWrapper/CardWrapper";
import AppointmentCardHeader from "ui/appointment/components/common/cards/AppointmentCardHeader/AppointmentCardHeader";
import AppointmentCardBody from "ui/appointment/components/common/cards/AppointmentCardBody/AppointmentCardBody";
import { useAppSelector } from "lib/redux/hooks";
import { selectCreateAppointment } from "ui/appointment/ducks/selectors";

const ConfirmationCard = ({
  slotDateTime,
  institution,
  service,
  location,
  zoneInfo,
}: ConfirmationCardProps) => {
  // Redux States
  const { selectedPractitioner: selectedConsultant } = useAppSelector(
    selectCreateAppointment,
  );
  return (
    <CardWrapper isLinkedAppointmentStyled={false}>
      <Box sx={{ display: "flex" }}>
        <AppointmentCardHeader datetime={slotDateTime} isHighlighted={true} />
        <AppointmentCardBody
          institution={institution || ""}
          datetime={slotDateTime}
          departmentName={null}
          clinician={selectedConsultant?.name ?? ""}
          location={location}
          zoneInfo={zoneInfo}
          serviceDisplayName={service}
          visitType={null}
          isVcp={false}
        />
      </Box>
    </CardWrapper>
  );
};

export default ConfirmationCard;
